<template>
    <div class="module">
        <header class="module__header">
            <a
                class="back-btn"
                @click="goBack('super-radios-summary')"
            >
                <span class="icon-chevron-left" />
            </a>

            <h1 class="has-back-btn">Create Radio</h1>
        </header>

        <section class="module__body">
            <form
                class="full-width"
                @submit.prevent="createRadio"
            >
                <div class="form-flex">
                    <div class="form-flex-group">
                        <RadioSerialNumberField
                            id="serial_number"
                            v-model="serial_number"
                            data-test-id-prefix="serial-number"
                            label="Serial Number"
                            :radio-type="radioTypes.PRO_X2"
                            :required="true"
                        />

                        <div class="form-group">
                            <label for="architecture">Firmware Architecture</label>
                            <select
                                id="architecture"
                                v-model="architecture"
                                data-test-id="architecture_selector"
                                required
                            >
                                <option
                                    v-for="(arch, index) in architectures"
                                    :key="index"
                                    :value="arch.type"
                                >
                                    {{ arch.label }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="purchase_order">Purchase Order</label>
                            <input
                                id="purchase_order"
                                v-model="purchase_order"
                                type="text"
                                required
                                minlength="9"
                                maxlength="9"
                                pattern="^\d{2}(?:0[1-9]|1[0-2])-\d{4}$"
                                data-test-id="purchase_order_input"
                                placeholder="2412-1234"
                            />
                            <div class="help">
                                Purchase Order format is 2 digit year, 2 digit month, hyphen, and 4 digits
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Premium Authorized</label>
                            <slider-toggle-field
                                name="isPremiumAuthorized"
                                label=""
                                :value="is_premium_authorized"
                                @update="is_premium_authorized = $event"
                            ></slider-toggle-field>
                        </div>
                    </div>
                    <div class="form-flex-group">
                        <div class="form-group">
                            <label>Organization</label>
                            <organization-selector
                                :organizationId="organization_id"
                                data-test-id="organization_selector"
                                @update="organizationUpdated"
                            />
                        </div>
                        <div class="form-group">
                            <label for="customer">Customer</label>
                            <input
                                id="customer"
                                v-model="customer"
                                type="text"
                                minlength="3"
                                maxlength="191"
                                data-test-id="customer_input"
                            />
                        </div>
                        <div class="form-group">
                            <label for="notes">Notes</label>
                            <textarea
                                id="notes"
                                v-model="notes"
                                data-test-id="notes_input"
                                class="short"
                                maxlength="191"
                            />
                        </div>
                    </div>
                </div>

                <form-errors :response="errorResponse"></form-errors>

                <div class="form-group">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        :class="{ active: submitted }"
                    >
                        <div>Create</div>
                    </button>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import RadioSerialNumberField from '@/components/RadioSerialNumberField.vue'
import canToast from '@/mixins/canToast'
import radioTypes from '@/constants/radio-types.js'
import hasBackButton from '@/mixins/hasBackButton'
import SliderToggleField from '@/components/SliderToggleField.vue'
import OrganizationSelector from '@/components/OrganizationSelector.vue'
import architectures from '@/constants/firmware-architectures'

export default {
    components: {
        FormErrors,
        SliderToggleField,
        OrganizationSelector,
        RadioSerialNumberField,
    },

    mixins: [canToast, hasBackButton],

    data() {
        let organizationId = null

        if (this.$route.query.organization_id) {
            organizationId = parseInt(this.$route.query.organization_id, 10)
        }

        return {
            serial_number: null,
            purchase_order: null,
            customer: null,
            notes: null,
            organization_id: organizationId,
            is_premium_authorized: false,
            architecture: architectures[0].type,
            architectures,
            errorResponse: null,
            submitted: false,
            radioTypes,
        }
    },

    methods: {
        createRadio() {
            this.submitted = true

            this.$http
                .post('radios', {
                    serial_number: this.serial_number,
                    purchase_order: this.purchase_order,
                    customer: this.customer,
                    notes: this.notes,
                    organization_id: this.organization_id,
                    architecture: this.architecture,
                    is_premium_authorized: Number(this.is_premium_authorized),
                })
                .then(() => {
                    this.toast('Radio successfully added!')
                    this.$router.push('/radios')
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.submitted = false
                })
        },

        organizationUpdated(event) {
            this.organization_id = event
        },
    },
}
</script>
